import { getPhotoData } from '../object-data/im-object-data.helper';

import { CustomData } from '@shared/analytics/models/analytics/analytics.models';
import { EventData } from '@shared/analytics/models/general/general.models';

export const getEventDataCf = (parent?: string): string | null => {
    const eventDataCfLiteral: Record<string, string> = {
        'footer-comfy': 'footer',
        'intro-member': 'newsletter',
        'member-get-member': 'newsletter',
        default: null,
    };
    return eventDataCfLiteral[parent] || eventDataCfLiteral.default;
};

export const getEventDataCategory = (parent?: string): string | null => {
    const eventDataCatLiteral: Record<string, string> = {
        'footer-comfy': 'footer',
        'intro-member': 'landing',
        'member-get-member': 'landing',
        default: null,
    };
    return eventDataCatLiteral[parent] || eventDataCatLiteral.default;
};

export const getEventDataAction = (parent?: string): string | null => {
    const eventDataActLiteral: Record<string, string> = {
        'footer-comfy': 'click_footer_link',
        'intro-member': 'start_now',
        'member-get-member': 'start_now',
        default: null,
    };
    return eventDataActLiteral[parent] || eventDataActLiteral.default;
};

export const getEventDataLabel = (parent?: string, sponsorcode?: string): string | null => {
    const eventDataLabelLiteral: Record<string, string> = {
        'intro-member': undefined,
        'member-get-member': sponsorcode,
        default: null,
    };
    return parent && (typeof eventDataLabelLiteral[parent] === 'string' || eventDataLabelLiteral[parent] === undefined)
        ? eventDataLabelLiteral[parent]
        : eventDataLabelLiteral.default;
};

export const getLabelById = (id: string): string => {
    const staticNames: any = {
        1831519: 'curalate',
        1769045: 'landing_newsletter',
        1866513: 'landing_tiendas',
    };
    return staticNames[id];
};

export const parserLabel = (label: string): string => {
    let newLabel: string = label || '';
    newLabel = newLabel.replace('@', '');
    newLabel = newLabel.replace(/^bg/i, 'boys & girls');
    return getLabelById(newLabel) || newLabel;
};

export const clickOnComponentCms = (
    component: string,
    label: string,
    linkType: string,
    section: string,
    id?: string,
    parent?: string,
    sponsorcode?: string
): { eventData: EventData; extraData: CustomData } => {
    const cf = component === 'enlace_texto' ? 'navegacion' : 'catalogo';
    const sectionFromParent = parent === 'gift-card' ? parent : section;

    const eventDataCf: string = getEventDataCf(parent);
    const eventDataCat: string = getEventDataCategory(parent);
    const eventDataAct: string = getEventDataAction(parent);
    const eventDataLabel: string = getEventDataLabel(parent, sponsorcode);

    const eventData: EventData = {
        cf: eventDataCf ?? cf,
        category: eventDataCat ?? sectionFromParent,
        action: eventDataAct ?? `click_${component}`,
        label: eventDataLabel || eventDataLabel === undefined ? eventDataLabel : parserLabel(label),
        debugId: id,
    };

    const extraData: CustomData = {
        photo: getPhotoData(linkType),
    };
    return { eventData, extraData };
};
